import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../data/menu";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-cream py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-6 relative"
        >
          <div className="zoom-wrap relative aspect-[4/5] max-w-[480px] mx-auto">
            <img
              src={ASSETS.interior}
              alt="Inside OROMA — warm pendant lights and the espresso bar"
              className="w-full h-full object-cover"
              data-testid="about-interior-image"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 lg:right-10 bg-cream border border-espresso/15 px-5 py-3 shadow-sm">
            <p className="font-script text-2xl text-espresso italic">est. Mumbai</p>
          </div>
        </motion.div>

        <div className="lg:col-span-6">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="inline-flex items-center gap-3 text-espresso/60 text-[12px] tracking-[0.3em] uppercase mb-6"
          >
            <span className="h-px w-10 bg-espresso/40" />
            About Oroma
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-espresso text-balance"
            data-testid="about-heading"
          >
            Crafted for slow mornings <br />
            <span className="italic text-espresso/80">& meaningful conversations.</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.15 }}
            className="mt-8 max-w-xl text-soft/75 leading-[1.85] text-[15px]"
          >
            OROMA is a modern café experience in the heart of Mumbai, blending
            artisanal coffee, comfort food, and aesthetic ambiance. From
            handcrafted cold brews to indulgent pastas and matcha creations,
            OROMA is designed for people who appreciate good taste and good
            moments.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.3 }}
            className="mt-10 grid grid-cols-3 gap-6 max-w-md"
          >
            {[
              { k: "Single-origin", v: "Beans" },
              { k: "Slow-steeped", v: "Cold brews" },
              { k: "Hand-finished", v: "Plates" },
            ].map((s) => (
              <div key={s.k} className="border-t border-espresso/20 pt-3">
                <p className="font-serif text-xl text-espresso">{s.k}</p>
                <p className="text-[11px] tracking-[0.22em] uppercase text-espresso/60 mt-1">
                  {s.v}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
